import { Stack } from '@mui/material'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import { TypographySecondaryBold16 } from 'ui/typography/TypographySecondaryBold16'

import { FEED_CONSUMPTION_MESSAGES } from '../constants'

export const FeedConsumptionErrorState = () => (
	<Stack justifyContent='center' alignItems='center'>
		<TypographySecondaryBold16>
			{FEED_CONSUMPTION_MESSAGES.errorTitle}
		</TypographySecondaryBold16>
		<TypographySecondary14 sx={{ marginTop: '12px' }}>
			{FEED_CONSUMPTION_MESSAGES.errorDescription}
		</TypographySecondary14>
	</Stack>
)
